import React,{useState, useEffect, Fragment} from "react";
import { Link, useParams, useNavigate } from 'react-router-dom'
import { eligibility, api, schoolsApiurl, schoolsurl } from "../../../apis/urls";
import axios from "axios";
import Checkbox from "./Checkbox";
import CheckIcon from "../../../images/check.svg";
import CrossIcon from "../../../images/cross.svg";
import HourGlassIcon from "../../../images/hourglass-end.svg";
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import moment from "moment";
import { map } from "jquery";
import { decode } from 'html-entities'
import Loader from "../../../common-components/loader";
import { Grid } from "@nextui-org/react";
import { message } from "antd";


const AthletList = () => {


    useEffect( ()=> {
        setLoader(true)
        AthleticListing(50);
        SchoolName();
        $('body').removeClass('').addClass('sidebar-collapsed');
    },[])

    let sizes = '50';
    let changePagesize = (e) => {
        sizes = e.target.value;
        AthleticListing(sizes);
        setPageCount(sizes)
        console.log("pages", sizes)

    }

    const { id } = useParams();
    let navigate = useNavigate();

    

    let user_role = localStorage.getItem('userrole');


    const [loader,setLoader] = useState(false);
    const [pageCount, setPageCount] = useState("50")
    // const[ checked, setChecked ] = useState(false)
    const [result,setResult] = useState([])
    const [searchTitle, setSearchTitle] = useState("");
    const [approval, setApproval] = useState("APPROVED");
    const [rejected, setRejected] = useState("REJECTED");
    const [selected, setSelected] = useState([]);
    const [schName,setSchName] = useState([]);
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);
    const [emptyItem, setEmptyItem] = useState(false);
    const [selectedval, setSelectedval] = useState('');
    const [statusselectedval, setStatusselectedval] = useState('');
    const [gradep, setGradep] = useState("");
    const [searchf, setSearchf] = useState("");
    const [approvef, setApprovef] = useState("");
    const [approveType, setApproveType] = useState("");



    let counts = 0;
    if(result)
    {
        counts = result.length;
    }








    let token = "Bearer "+localStorage.getItem('token');
    const instances = axios.create({
        baseURL: api,
        timeout: 1000000,
        headers: {'authorization': token}
    });

    const onChangeSearchTitle = (e) => {
        const searchTitle = e.target.value;
        setSearchTitle(searchTitle);
        setSearchf(e.target.value)

        // console.log("search status", searchf)
        // console.log("grade status", gradep)
        // console.log("sapprove statusType", approveType)
        // console.log("approve status", approvef)

        let filterParams ='';

        if(approvef !== '')
        {
            if(approveType === 'ho')
            {
                filterParams+=`&ho_approval=`+approvef

            }else if(approveType === 'gisa')
            {
                filterParams+=`&approval=`+approvef
                
            }else if(approveType === 'pho')
            {
                filterParams+=`&ho_approval=`+approvef
                
            }else if(approveType === 'pgisa')
            {
                filterParams+=`&approval=`+approvef
                
            }else if(approveType === 'all')
            {
                filterParams+=''
                
            }else{

            }
            

        }

        if(gradep !== '')
        {
            filterParams+=`&grade=`+gradep

        }

        

        // findByTitle();

        instances.get(eligibility+id+`?page=`+0+`&size=`+pageCount+`&search=`+searchTitle+filterParams)
            .then(response => {
                if(response.data.message=== "Success"){
                    setResult(response.data.data.items)
                    setTotalItems(response.data.data.totalItems)
                    setTotalPages(response.data.data.totalPages)
                    setEmptyItem(false)

                }else{
                    setResult(false)
                    setEmptyItem(true)
                }
          })
            .catch(e => {
            console.log(e);
          });
    };


    const findByTitlesss = option => {


        


        let filterParams = '';

        if(searchf !== '')
        {
            filterParams = `&search=`+searchf;
        }

        if(approvef !== '')
        {
            if(approveType === 'ho')
            {
                filterParams+=`&ho_approval=`+approvef

            }else if(approveType === 'gisa')
            {
                filterParams+=`&approval=`+approvef
                
            }else if(approveType === 'pho')
            {
                filterParams+=`&ho_approval=`+approvef
                
            }else if(approveType === 'pgisa')
            {
                filterParams+=`&approval=`+approvef
                
            }else if(approveType === 'all')
            {
                filterParams+=''
                
            }else{

            }
            

        }
        



         return instances.get(`eligibilities/school/`+id+`?page=`+0+`&size=`+pageCount+`&grade=${option}`+filterParams);
        //return instances.get(`eligibilities/school/`+id+`?page=`+0+`&size=`+pageCount+`search=`+searchTitle+`&grade=${option}``&approval=`+approveFilter);
    };
    const onChangeSearchTitles = (e) => { 
        let searchTitle = e.target.value;


        setGradep(e.target.value)
        if(searchTitle === 'ALL')
        {
            searchTitle='';
            setGradep('')
        }else{
            searchTitle = searchTitle;
        }
        console.log('value',searchTitle)

        // setSelectedval("selected")

        // setStatusselectedval("")

        findByTitlesss(searchTitle)
        .then(response => {
            if(response.data.message=== "Success"){
                setResult(response.data.data.items)
                setTotalItems(response.data.data.totalItems)
                setTotalPages(response.data.data.totalPages)
                setEmptyItem(false)

            }else{
                setResult(false)
                setEmptyItem(true)
            }
        })
        .catch(e => {
            console.log(e);
        });
    };


    // const findByTitle = option => {
    //     return instances.get(`eligibilities/school/`+id+`?approval=${option}`);
    // };

    const  [approveFilter, setApproveFilter] = useState()
    
    const onChangeSearchTitless = (e) => {

        
        const searchTitles = e.target.value
        const searchTitle =  e.target[e.target.selectedIndex].getAttribute('data-value');
        console.log("click",)
        setApprovef(e.target.value)
        setApproveType(e.target[e.target.selectedIndex].getAttribute('data-value'))
        


        const findByTitle = option => {

            // setStatusselectedval("selected")
            // setSelectedval("")
   

        let filterParams = '';

        if(searchf !== '')
        {
            filterParams = `&search=`+searchf;
        }

        if(gradep !== '')
        {
            filterParams+=`&grade=`+gradep

        }


        console.log('params',filterParams)

        if( searchTitle === "ho"){

           

            return instances.get(`eligibilities/school/`+id+`?page=`+0+`&size=`+pageCount+`&ho_approval=${option}`+filterParams);

            //return instances.get(`eligibilities/school/`+id+`?page=`+0+`&size=`+pageCount+`search=`+searchTitle+`&grade=${option}``&ho_approval=`+approveFilter);

            
        }else if(searchTitle === "gisa"){

            return instances.get(`eligibilities/school/`+id+`?page=`+0+`&size=`+pageCount+`&approval=${option}`+filterParams);


        }else if( searchTitle === "pho"){
            

            return instances.get(`eligibilities/school/`+id+`?page=`+0+`&size=`+pageCount+`&ho_approval=${option}`+filterParams);
            
        }else if(searchTitle === "pgisa"){
            

            return instances.get(`eligibilities/school/`+id+`?page=`+0+`&size=`+pageCount+`&approval=${option}`+filterParams);
            

        }else if( searchTitle === "all"){

            return instances.get(`eligibilities/school/`+id+`?page=`+0+`&size=`+pageCount+filterParams);

        }else{

            return instances.get(`eligibilities/school/`+id+`?page=`+0+`&size=`+pageCount+`&status=${option}`+filterParams);
            
        }
        
        
        
        };

        
        findByTitle(searchTitles)
        .then(response => {
            if(response.data.message=== "Success"){
                setResult(response.data.data.items)
                setTotalItems(response.data.data.totalItems)
                setTotalPages(response.data.data.totalPages)
                setEmptyItem(false)

            }else{
                setResult(false)
                setEmptyItem(true)
            }
        })
        .catch(e => {
            console.log(e);
        });
    };







    const AthleticListing = (sizeCount) => {
        const instance = axios.create({

            baseURL: eligibility+id+'?page='+0+'&size='+sizeCount,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            if(response.data.message === "Success"){
            setLoader(false)
            setResult(response.data.data.items);
            setCurrentpage(response.data.data.currentPage)
            setTotalPages(response.data.data.totalPages)
            setTotalItems(response.data.data.totalItems)  
            // console.log('resultssssss',response.data.data.items)
             }else{
            setLoader(false)
            setEmptyItem(true)
            // console.log("faculty data", response.data.message)
        }
                     
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }


    const SchoolName = () => {

		

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolsurl+'/'+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setSchName(response?.data?.data?.name);
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }



  

   

        const approveAthletic = (aid) => {

                    
            // console.log('aid', aid)

            let token = "Bearer "+localStorage.getItem('token');

            const datas = {
                ids:isCheck,
                approval:approval
            }
            const instance = axios.create({
                baseURL: eligibility+id+"/3/approve",
                timeout: 1000000,
                headers: {'authorization': token}
            });
            instance.patch('',datas).then((response) =>{
                window.location.reload();
                // navigate("/athlet_list/"+id)
                 
            }).catch((error) =>{     
                console.log('error',error.message)  
            });
        }

        const [rejectvalue, setRejectValue] = useState('')
        const [rejectReason, setRejectReason] = useState(false)
        const [rejectReasonError, setRejectReasonError] = useState(false) 




        const rejectedAthletic = (aid) => {
            
            if(isCheck.length === 1){

            setAllFiles(false)
            setRejectReason(true)
            }
            else{
                alert('Select one item to Reject')
                setAllFiles(true)
                setRejectReason(false)
    
            }
        }

        const submitRejectReason = (aid) => {

            if(rejectvalue===""){

                window.location.reload();
                setAllFiles(true)
                setRejectReason(false)
                alert("Enter valid reason")
                
            }
            else{


            let token = "Bearer "+localStorage.getItem('token');
            const datas = {
                ids:[rejectedselected],
                approval:rejected
            }
            const instance = axios.create({
                baseURL: eligibility+id+"/"+aid+"/approve",
                timeout: 1000000,
                headers: {'authorization': token}
            });
            instance.patch('',datas).then((response) =>{  



            }).catch((error) =>{     
                console.log('error',error.message)
            }); 




            const datass = {
                ineligible_reason:rejectvalue
            }
            const instances = axios.create({
                baseURL: eligibility+id+"/"+rejectedselected+"/ineligiblereason",
                timeout: 1000000,
                headers: {'authorization': token}
            });
            instances.patch('',datass).then((response) =>{  
                setAllFiles(true)
                setRejectReason(false)

                window.location.reload();

                // navigate("/athlet_list/"+id)
                // console.log("success")
            }).catch((error) =>{     
                console.log('error',error.message)
            });
        }




        }

        

        const [confirmPromote, setConfirmPromote] = useState(false)

        const ConfirmPromoteBtn =()=> {
            if(isCheck.length >= 1){
                setConfirmPromote(true)
                setAllFiles(false)
            }
            else{
                alert('Select one item to Promote')
                setAllFiles(true)
                setConfirmPromote(false)
            }
        }

        const promoteAthletic = () => {

            // alert('Agree to Promote')

            let token = "Bearer "+localStorage.getItem('token');

            const datas = {
                ids:isCheck,
            }
            const instance = axios.create({
                baseURL: eligibility+id+"/promote",
                timeout: 1000000,
                headers: {'authorization': token}
            });
            instance.patch('',datas).then((response) =>{

                window.location.reload();

                // navigate("/athlet_list/"+id)
                // console.log("success")
            }).catch((error) =>{     
                console.log('error',error.message)  
            });
        }


        const [exports, setExports] = useState(false)
        const [exportvalue, setExportValue] = useState(false)
        const [allfiles, setAllFiles] = useState(true)
        const [sampleFile, setSampleFile] = useState('')

        // Export Athletic

        const exportAtletic  = () => { 

        //     let token = "Bearer "+localStorage.getItem('token');

            let token = "Bearer "+localStorage.getItem('token');

            const instance = axios.create({
                baseURL: api+"impex/athletic/"+id,
                timeout: 1000000,
                headers: {'authorization': token}
            });
            instance.get('').then((response) =>{
                // setAllFiles(false)
                window.open(api+"impex/download/"+response.data.fileName, '_blank')
                // setSampleFile(api+"impex/download/sample_file.xlsx")

                // navigate(api+"impex/download/"+response.data.file)

            }).catch((error) =>{     
                console.log('error',error.message)  
            });
        }

        const dismissButton =()=>{
                // window.location.reload();
                setExports(false)
                setOpenImport(false)
                setConfirmPromote(false)
                setRejectReason(false)
                setImportDataError(false)
                setAllFiles(true)
           
        }

        const dismissButtonImport =()=>{
            window.location.reload();
            setExports(false)
            setOpenImport(false)
            setConfirmPromote(false)
            setRejectReason(false)
            setImportDataError(false)
            setAllFiles(true)
       
    }
       

     const [openImport, setOpenImport] = useState(false)   

     const importnavigate =()=>{
        setOpenImport(true)
        setAllFiles(false)
     }

     const handlePageClick = (event) => { console.log('EVENTSSS',event)
     //console.log('title show',gradep)
     let instance=''


     let filterParams ='';

        if(searchf !== '')
        {
            filterParams = `&search=`+searchf;
        }


        if(gradep !== '')
        {
            filterParams+=`&grade=`+gradep
        }

        if(approvef !== '')
        {
            if(approveType === 'ho')
            {
                filterParams+=`&ho_approval=`+approvef

            }else if(approveType === 'gisa')
            {
                filterParams+=`&approval=`+approvef
                
            }else if(approveType === 'pho')
            {
                filterParams+=`&ho_approval=`+approvef
                
            }else if(approveType === 'pgisa')
            {
                filterParams+=`&approval=`+approvef
                
            }else if(approveType === 'all')
            {
                filterParams+=''
                
            }else{

            }
            

        }

       
        instance = axios.create({
            baseURL: eligibility+id+`?page=`+event.selected+`&size=`+pageCount+filterParams,
            timeout: 1000000,
            headers: {'authorization': token}
          });


     instance.get('').then(res => {

         setResult(res.data.data.items)
         console.log("size count" , pageCount)

     
         
     }).catch(e => {
     //console.log('errorshw',e);
     localStorage.removeItem('token')
     navigate("/")
     });


 };
    let sl =1; 





    const [selectedFile, setSelectedFile] = useState(); 
    const [selectedFilechoose, setSelectedFilechoose] = useState(false); 
    const [selectedFilename, setSelectedFilename] = useState(); 
    const [rejectedselected, setRejectSelected] = useState()

	const changeHandler = (event) => {

		setSelectedFile(event.target.files[0]);
        setSelectedFilename(event.target.files[0].name)
        setSelectedFilechoose(true) 
        
		// setIsSelected(true);
	};





    const [ importdataError, setImportDataError ] = useState('')
    const [ errorImport, setErrorImport] = useState(false)
    const [successImport, setSuccessImport] = useState(false)

    const handleSubmission  = (event, e) => {


        let token = "Bearer "+localStorage.getItem('token');

        const data = new FormData();

        data.append('importFile', selectedFile)

        const instance = axios.create({
            baseURL: api+"impex/athletic",
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });


        instance.post('', data).then((response) =>{


            if( response.data.failed_data.length === 0 ){
            // setAllFiles(true)
            // setOpenImport(false)
            // window.location.reload();    
            // alert('import successfully')
            setSuccessImport(true)
            console.log("response.data.failed_data", response.data)
            }
            else{
            setImportDataError(response.data.failed_data)
            setErrorImport(true)
            console.log("import", response.data)
            alert("Data failed show more details below")
            }

        }).catch((error) =>{     
            if(error?.response?.data === "Please upload an excel file!"){
                message.success('Please upload an excel file!');
            }
            console.log('error',error?.response?.data)  
        });
    }

    const [isCheck, setIsCheck] = useState([]);
    const [isCheckAll, setIsCheckAll] = useState(false);
  

  
    const handleSelectAll = (e) => {
      setIsCheckAll(!isCheckAll);
      setIsCheck(result.map((li) => li.id));
      console.log("check all", isCheck)
      if (isCheckAll) {
        setIsCheck([]);
      }
    };
  
    const handleClick = (e) => {
      const { id, checked } = e.target;
    //   console.log("eee", e.target)
      let selectId = parseInt(id)
      setIsCheck([...isCheck, selectId]);
      setRejectSelected(id)
      if (!checked) {
        setIsCheck(isCheck.filter((item) => item !== selectId));
      }
    //   console.log("isCheck", isCheck);
    };
  
    console.log(isCheck);
  




    $(function($) {

        $('.form-textarea')
            .each(function(){
                var $this = $(this);
                $this.css('min-height', $this.css('height'));
                $this.css('overflow', 'hidden');
            })
            .on('input paste', function() {
                var $this = $(this);
                var offset = $this.innerHeight() - $this.height();
    
                if ($this.innerHeight < this.scrollHeight) {
                    // Grow the field if scroll height is smaller
                    $this.height(this.scrollHeight - offset);
                } else {
                    // Shrink the field and then re-set it to the scroll height in case it needs to shrink
                    $this.height(1);
                    $this.height(this.scrollHeight - offset);
                }
            });
    });
    

    const calculateAge = (birthDate) => {
        const today = new Date();
        const birth = new Date(birthDate);
        let age = today.getFullYear() - birth.getFullYear();
        const monthDifference = today.getMonth() - birth.getMonth();
    
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birth.getDate())) {
          age--;
        }
    
        return age;
      }; 




    return(
        <div>
            <aside className="right-side" style={{background:!confirmPromote?null:'#fff'}}>
                {allfiles=== true?
                <div class="content-area dash-contentss">

                <div class="page-title-wrpr">
                    <div class="page-title-left-column">
                        <i class="icon-library1"></i>
                        <h2 class="page-title"> Athletic Eligibility - {decode(schName)}</h2>
                    </div>
                    <div class="page-rightside-action-column">
                        <Link to={"/athlet_add/"+id} data-toggle="tooltip" title="" class="addbtnitem-link text-anchor athletic-add-text" data-original-title="Add New School"><i class="icon-add"></i><span>Add New Athletic Eligibility</span> </Link>
                    </div>
                </div> 






                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        {  user_role === "SUPERADMIN"?
                        (<Fragment>
                        <li class="breadcrumb-item"><Link to="/school_list">School List</Link></li>
                        </Fragment>
                        ):null
                        }
                        <li class="breadcrumb-item active" aria-current="page">Athletic Eligibility</li>
                    </ol>
                </nav>



                



                <div class="btn-top-cntnr">
					<div class="row">


            {emptyItem? <div class="col-md-5 btn-container"></div>:
            user_role ==="ATHLETIC_MANAGER"?<div class="col-md-5 btn-container">
                    </div>:


                <div class="col-md-5 btn-container">
                        <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={()=>{rejectedAthletic(selected)}}>Ineligible</button>
                        <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={()=>{approveAthletic(selected)}}>Approve</button>
                        {user_role ==="SUPERADMIN"?
                        // <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={()=>{promoteAthletic(selected)}}>Promote</button>
                        <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={ConfirmPromoteBtn}>Promote</button>
                        
                        :null
                        }

                </div>}


						<div class="col-md-7 text-right">
						
						<div class="customsearch-group">
							<div class="input-group  customsearch-wrpr select-group">
                            <div class="input-group-prepend" style={{marginLeft:"-50px"}}>
                                <select class="btn btn-outline-secondary" onChange={onChangeSearchTitless}>
                                    <option value="none" selected disabled hidden>STATUS</option>
                                    <option value="All" data-value="all" >All</option>
                                    <option value="APPROVED" data-value="gisa">APPROVED by GIAA</option>
                                    <option value="APPROVED" data-value="ho" >APPROVED by HOS</option>
                                    <option value="PENDING" data-value="pgisa">PENDING BY GIAA</option>
                                    <option value="PENDING" data-value="pho">PENDING BY HOS</option>
                                    <option value="INACTIVE" data-value="ina">ARCHIVED</option>
                                    {/* <option>ACTIVE</option>
                                    <option>INACTIVE</option>
                                    <option>DELETED</option> */}
                                </select> 
                            </div>

                            <div class="input-group-prepend">
                                <select class="btn btn-outline-secondary" onChange={onChangeSearchTitles}>
                                    <option value="none" selected disabled hidden>GRADE</option>
                                    <option value="ALL">ALL</option>
                                    <option>8</option>
                                    <option>9</option>
                                    <option>10</option>
                                    <option>11</option>
                                    <option>12</option>
                                </select> 
                            </div>


							</div>
							<div class="input-group  customsearch-wrpr">
							  <input type="text" 
                                value={searchTitle}
                                onChange={onChangeSearchTitle}
                                className="form-control searchLine" 
                                placeholder="Search" />
                              
							  <div class="input-group-append">
								<button class="btn btn-success " type="submit">Search</button>
							  </div>
							</div>
						</div>	
							
						</div>
					</div>
				</div>

                  
                <div class="number-of mt-4 row">
                    <div class="col-md-5  page-count-wrpr footer-number">
                        Displaying 1-{counts} of {totalItems} results.
                    </div>
                    <div class="col-md-7  page-count-wrpr footer-number">
                    </div>
                </div>

                <div class="number-of mt-3 row">
                    <div class="col-md-2  page-count-wrpr footer-number">
                        <select className="form-control bg-light dark-theme showtext" onChange={changePagesize} id="status-selector">
                            <option value="50">Select pages</option>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
                    

                <div class="faculty-list-wrpr list-wrpr">

                    {/* super admin start */}

                    { 
                        loader?
                        <div>
                            <div className="loader_container"><Loader/></div>
                        </div>
                        :
                        null
                    }

                  
        { user_role ==='SUPERADMIN'?
            <div class="table-wrpr mt-5" style={{overflow:'auto'}}>
                <table class="table sml-font" >
                    <thead>
                        <tr>
                            <th width="40px" style={{marginTop:"55px"}}>
                                <div class="faculty-user checkbox-btn-options">
                                    <span>&nbsp;</span> 

                            <Checkbox
                                    type="checkbox"
                                    name="selectAll"
                                    id="selectAll"
                                    handleClicks={handleSelectAll}
                                    isChecked={isCheckAll}
                                />   



                                </div>
                            </th>
                            <th width="40px" style={{paddingLeft:"5px"}}>GIAA Status</th>
                            <th width="40px" style={{paddingLeft:"5px"}}>Hos Status</th>
                            <th style={{paddingLeft:"5px"}}>Name</th>
                            <th style={{paddingLeft:"5px"}}>Grade</th>
                            <th style={{paddingLeft:"5px"}}>DOB</th>
                            <th style={{paddingLeft:"5px"}}>Age</th>
                            <th style={{paddingLeft:"5px"}}>Entered 8th</th>
                            <th style={{paddingLeft:"5px"}}>Entered 9th</th>
                            <th style={{paddingLeft:"5px"}}>Date of Transfer</th>
                            <th style={{paddingLeft:"5px"}}>Units</th>
                            <th style={{paddingLeft:"5px"}}>Created at</th>
                            <th style={{paddingLeft:"5px"}}>XFR</th>
                            <th style={{paddingLeft:"5px"}}>Actions</th> 
                        </tr>
                    </thead>
                <tbody>
   
            
            { result?(
                <Fragment>
                {result.map((item,index, ids, name)=> (
                        
                    <Fragment>
                            <Fragment>

                            {item.current_grade ==="13"?null:
                        <tr> 


                            <td class="checkbox-cntnr" style={{width:'40px'}}>
                                <div class="faculty-user checkbox-btn-options athletic">
                                    <span>&nbsp;</span>
                                    <Checkbox
                                        key={ids}
                                        type="checkbox"
                                        name={name}
                                        id={item.id}
                                        handleClicks={handleClick}
                                        isChecked={isCheck.includes(item.id)}
                                        className="select-individual-check"
                                    />
                                </div>
                            </td>
                                
            

                            <Fragment>
                                    <td data-table-heading="Status" style={{paddingLeft:"5px"}}>
                                        <Fragment>
                                            {item.gisa_approval === "APPROVED"?
                                            <div className="approveGisa">
                                            <span style={{color:"green"}}>{item.gisa_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.gisa_approval === "REJECTED"?
                                            <div className="rejectGisa">
                                            <span style={{color:"red"}}>{item.gisa_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.gisa_approval === "PENDING"?
                                            <div className="pendingGisa">
                                            <span style={{color:"blue"}}>{item.gisa_approval}</span><br />
                                            </div>:null
                                            }
                                        </Fragment>
                                    </td>
                                    <td data-table-heading="Status" style={{paddingLeft:"5px"}}>
                                        <Fragment>

                                            {item.ho_approval === "APPROVED"?
                                            <div className="approveGisa">
                                            <span style={{color:"green"}}>{item.ho_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.ho_approval === "REJECTED"?
                                            <div className="rejectGisa">
                                            <span style={{color:"red"}}>{item.ho_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.ho_approval === "PENDING"?
                                            <div className="pendingGisa">
                                            <span style={{color:"blue"}}>{item.ho_approval}</span><br />
                                            </div>:null
                                            }
                                        </Fragment>
                                    </td>
                                </Fragment>

                                    <td data-table-heading="Name" style={{paddingLeft:"5px"}}>{decode(item.first_name)}&nbsp;{decode(item.last_name)}</td>
                                    <td data-table-heading="Grade" style={{paddingLeft:"5px"}}>{item.status === "INACTIVE" ? "Archived" : item.current_grade}</td>
                                    <td data-table-heading="DOB" style={{paddingLeft:"5px"}}>{item.dob}</td>
                                    <td data-table-heading="Age" style={{paddingLeft:"5px"}}>{calculateAge(item.dob)}</td>
                                    <td data-table-heading="Entered 8th" style={{paddingLeft:"5px"}}>{item.year_8}</td>
                                    <td data-table-heading="Entered 9th" style={{paddingLeft:"5px"}}>{item.year_9}</td>
                                    <td data-table-heading="Date of Transfer" style={{paddingLeft:"5px"}}>{item.date_transfered}</td>
                                    <td data-table-heading="Units" style={{paddingLeft:"5px"}}>{item.units_passed}</td>
                                    <td data-table-heading="Created at" style={{paddingLeft:"5px"}}>{moment(item.createdAt).format('MM-DD-YYYY')}</td>
                                    {item.aes_status ==="NO"?<td data-table-heading="Created at" style={{paddingLeft:"5px"}}>NO</td>:
                                    <td data-table-heading="Created at" style={{paddingLeft:"5px",   color:"tomato", fontWeight:'800'}}>YES</td>}
                                    <td data-table-heading="Actions" >

            
                                <div class="list-action-wrpr text-right roundicons-text" style={{float:'left'}}>
                                <Link  to={"/athletView/"+id+'/'+item.id} title="View" ><i class="view icon-eye"></i><span>View</span></Link>
	
                                </div>
                            </td>
            
                        </tr>
                        }
                        </Fragment>

                        </Fragment>))}
                        </Fragment>
                        )
                        
                        :null
                            }
                    </tbody>
                </table>   
            </div>:null
}

{/* super admin end */}

{/* ho admin start*/}


{ user_role ==='HO_SCHOOL'?
            <div class="table-wrpr mt-5">
            <table class="table sml-font"  style={{overflow:'auto'}}>
                <thead>
                    <tr>
                        <th width="30px">
                            <div class="faculty-user checkbox-btn-options ">
                                <span>&nbsp;</span>
                                <Checkbox
                                    type="checkbox"
                                    name="selectAll"
                                    id="selectAll"
                                    handleClicks={handleSelectAll}
                                    isChecked={isCheckAll}
                                />   
                            </div>
                        </th>
                        <th width="40px">GIAA Status</th>
                        <th width="40px">Hos Status</th>
                        <th>Name</th>
                        <th>Grade</th>
                        <th>DOB</th>
                        <th>Age</th>
                        <th>Entered 8th</th>
                        <th>Entered 9th</th>
                        <th>Date of Transfer</th>
                        <th>Units</th>
                        <th>Created at</th>
                        <th>XFR</th>
                        <th>Actions</th> 
                    </tr>
                </thead>
            <tbody>

                { result?(
                 result?.map((item,index, ids, name)=> (
                    
                            <Fragment>
                        <Fragment>

                        {item.current_grade ==="13"?null:
                    <tr> 




             
                    <td class="checkbox-cntnr">
                    <div class="faculty-user checkbox-btn-options athletic">
                        <span>&nbsp;</span>
                        <Checkbox
                                    key={ids}
                                    type="checkbox"
                                    name={name}
                                    id={item.id}
                                    handleClicks={handleClick}
                                    isChecked={isCheck.includes(item.id)}
                                    className="select-individual-check"
                                />
                            </div>
                            </td>

                            <Fragment>
                                    <td data-table-heading="Status" style={{paddingLeft:"5px"}}>
                                        <Fragment>
                                            {item.gisa_approval === "APPROVED"?
                                            <div className="approveGisa">
                                            <span style={{color:"green"}}>{item.gisa_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.gisa_approval === "REJECTED"?
                                            <div className="rejectGisa">
                                            <span style={{color:"red"}}>{item.gisa_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.gisa_approval === "PENDING"?
                                            <div className="pendingGisa">
                                            <span style={{color:"blue"}}>{item.gisa_approval}</span><br />
                                            </div>:null
                                            }
                                        </Fragment>
                                    </td>
                                    <td data-table-heading="Status" style={{paddingLeft:"5px"}}>
                                        <Fragment>

                                            {item.ho_approval === "APPROVED"?
                                            <div className="approveGisa">
                                            <span style={{color:"green"}}>{item.ho_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.ho_approval === "REJECTED"?
                                            <div className="rejectGisa">
                                            <span style={{color:"red"}}>{item.ho_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.ho_approval === "PENDING"?
                                            <div className="pendingGisa">
                                            <span style={{color:"blue"}}>{item.ho_approval}</span><br />
                                            </div>:null
                                            }
                                        </Fragment>
                                    </td>
                                </Fragment>

                                <td data-table-heading="Name">{decode(item.first_name)}&nbsp;{decode(item.last_name)}</td>
                                <td data-table-heading="Grade">{item.status === "INACTIVE" ? "Archived" : item.current_grade}</td>
                                <td data-table-heading="DOB">{item.dob}</td>
                                <td data-table-heading="Age">{calculateAge(item.dob)}</td>
                                <td data-table-heading="Entered 8th">{item.year_8}</td>
                                <td data-table-heading="Entered 9th">{item.year_9}</td>
                                <td data-table-heading="Date of Transfer">{item.date_transfered}</td>
                                <td data-table-heading="Units">{item.units_passed}</td>
                                <td data-table-heading="Created at">{moment(item.createdAt).format('MM-DD-YYYY')}</td>
                                {item.aes_status ==="NO"?<td data-table-heading="Created at" style={{paddingLeft:"5px"}}>NO</td>:
                                    <td data-table-heading="Created at" style={{paddingLeft:"5px",   color:"tomato", fontWeight:'800'}}>YES</td>}
                                <td data-table-heading="Actions">
        
                            <div class="list-action-wrpr text-right roundicons-text" style={{float:'left'}}>
                            <Link  to={"/athletView/"+id+'/'+item.id} title="View"><i class="view icon-eye"></i><span>View</span></Link>

                            </div>
                        </td>
        
                    </tr>
                    }
                    </Fragment>

                    </Fragment>))):null
                        }
                </tbody>
            </table>   
        </div>:null
}


{/* ho admin end */}


{/* athletic manager start */}

{ user_role ==='ATHLETIC_MANAGER'?
             <div class="table-wrpr mt-5">
             <table class="table sml-font"  style={{overflow:'auto'}}>
                 <thead>
                     <tr>
                         <th width="50px">GIAA Status</th>
                         <th width="50px">Hos Status</th>
                         <th>Name</th>
                         <th>Grade</th>
                         <th>DOB</th>
                         <th>Age</th>
                         <th>Entered 8th</th>
                         <th>Entered 9th</th>
                         <th>Date of Transfer</th>
                         <th>Units</th>
                         <th>Created at</th>
                         <th>XFR</th>
                         <th>Actions</th> 
                     </tr>
                 </thead>
             <tbody>

                 { result?(
                  result?.map((item,index)=> (
                     
                             <Fragment>
                         <Fragment>

                         {item.current_grade ==="13"?null:
                     <tr>

                                <Fragment>
                                    <td data-table-heading="Status" style={{paddingLeft:"15px"}}>
                                        <Fragment>
                                            {item.gisa_approval === "APPROVED"?
                                            <div className="approveGisa">
                                            <span style={{color:"green"}}>{item.gisa_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.gisa_approval === "REJECTED"?
                                            <div className="rejectGisa">
                                            <span style={{color:"red"}}>{item.gisa_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.gisa_approval === "PENDING"?
                                            <div className="pendingGisa">
                                            <span style={{color:"blue"}}>{item.gisa_approval}</span><br />
                                            </div>:null
                                            }
                                        </Fragment>
                                    </td>
                                    <td data-table-heading="Status" style={{paddingLeft:"15px"}}>
                                        <Fragment>

                                            {item.ho_approval === "APPROVED"?
                                            <div className="approveGisa">
                                            <span style={{color:"green"}}>{item.ho_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.ho_approval === "REJECTED"?
                                            <div className="rejectGisa">
                                            <span style={{color:"red"}}>{item.ho_approval}</span><br />
                                            </div>:null
                                            }
                                            {item.ho_approval === "PENDING"?
                                            <div className="pendingGisa">
                                            <span style={{color:"blue"}}>{item.ho_approval}</span><br />
                                            </div>:null
                                            }
                                        </Fragment>
                                    </td>
                                </Fragment>

                                 <td data-table-heading="Name">{decode(item.first_name)}&nbsp;{decode(item.last_name)}</td>
                                 <td data-table-heading="Grade">{item.status === "INACTIVE" ? "Archived" : item.current_grade}</td>
                                 <td data-table-heading="DOB">{item.dob}</td>
                                 <td data-table-heading="Age">{calculateAge(item.dob)}</td>
                                 <td data-table-heading="Entered 8th">{item.year_8}</td>
                                 <td data-table-heading="Entered 9th">{item.year_9}</td>
                                 <td data-table-heading="Date of Transfer">{item.date_transfered}</td>
                                 <td data-table-heading="Units">{item.units_passed}</td>
                                 <td data-table-heading="Created at">{moment(item.createdAt).format('MM-DD-YYYY')}</td>
                                {item.aes_status ==="NO"?<td data-table-heading="Created at">NO</td>:
                                    <td data-table-heading="Created at" style={{color:"tomato", fontWeight:'800'}}>YES</td>}
                                 <td data-table-heading="Actions">
         
                             <div class="list-action-wrpr text-right roundicons-text" style={{float:'left'}}>
                             <Link  to={"/athletView/"+id+'/'+item.id} title="View"><i class="view icon-eye"></i><span>View</span></Link>
 
                             </div>
                         </td>
         
                     </tr>
                     }
                     </Fragment>

                     </Fragment>))):null
                         }
                 </tbody>
             </table>   
         </div>:null
}

{/* athletic manager end */}

                    {
                    emptyItem?
                    (<div className="nodata">
                        <h2>Sorry! No Athletic Eligibility Found</h2>
                    </div>):null
    
                    } 


                {result?
                    (                
                        <div class="number-of mt-3 row">
                            <div class="col-md-5  page-count-wrpr footer-number">
                                Displaying 1-{counts} of {totalItems} results.
                            </div>
                            <div class="col-md-7  page-count-wrpr footer-number">
                            </div>
                        </div>
                    ):null
                }

                {emptyItem?
                    <div class="col-md-12 text-right">
                        <button className="btn btn-primary btn-gisa" type="button" onClick={importnavigate}>Import</button>
                    </div>
                    :(
                    user_role ==="ATHLETIC_MANAGER"?
                    <div class="col-md-5 btn-container" style={{paddingLeft:'0px'}}>
                        <Grid xs={4} style={{justifyContent:'flex-end'}}>
                            <div>
                                <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={()=>{exportAtletic(selected)}}>Export</button>
                                <button className="btn btn-primary btn-gisa reject-btn" type="button" onClick={importnavigate}>Import</button>
                            </div>
                        </Grid>
                    </div>:

                    <Grid.Container gap={2} justify="center">
                        <Grid xs={8}>
                            <div>
                            <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={()=>{rejectedAthletic(selected)}}>Ineligible</button>
                            <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={()=>{approveAthletic(selected)}}>Approve</button>
                            {user_role ==="SUPERADMIN"?
                                <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={ConfirmPromoteBtn}>Promote</button>
                                :null
                            }
                        </div>
                        </Grid>
                        <Grid xs={4} style={{justifyContent:'flex-end'}}>
                            <div>
                                <button className="btn btn-primary btn-gisa cancelbtn reject-btn" type="button" onClick={()=>{exportAtletic(selected)}}>Export</button>
                                <button className="btn btn-primary btn-gisa reject-btn" type="button" onClick={importnavigate}>Import</button>
                            </div>
                        </Grid>
                    </Grid.Container>

                    )
                    
                }
            </div> 
                </div>:<div></div>}

                {rejectReason || exports || openImport || confirmPromote?null:     

                <div>
                {emptyItem?null:
                <div class="pagination-wrpr">
                    <ReactPaginate
                        className="pagination page"
                        pageClassName="page-item"
                        activeClassName="active"
                        nextLabel=">"
                        previousLabel="<"
                        previousClassName="page-link p-link"
                        nextClassName="page-link p-link"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={10}
                        pageCount={totalPages}
                        renderOnZeroPageCount={1}
                        />
                </div>
                }   
                </div>
                }

                {rejectReason?        

                        <div class="courses-container" style={{position:'absolute'}}>
                            <div class="course">
                                <div class="course-preview">
                                    <h6>&nbsp;</h6>
                                    <h2 style={{color:'#fff'}}>Ineligible Reason</h2>
                                    <a>&nbsp;<i class="fas fa-chevron-right"></i></a>
                                </div>
                                <div class="course-info">
                                <h6>&nbsp;</h6>
                                    <textarea type="text" 
                                        class="form-textarea" 
                                        placeholder="Enter Reason" 
                                        rows="4"
                                        value={rejectvalue} 
                                        onChange={e => { setRejectValue(e.target.value) }}  /><br/><br/><br/><br/><br/>


                                    <button onClick={dismissButton} class="btn reason-dismiss" data-dismiss="alert" aria-label="Close" data-abc="true">Dismiss</button> 
                                    <button onClick={submitRejectReason} data-dismiss="alert" aria-label="Close" data-abc="true" class="btn reason-submit">Submit</button>
                                </div>
                            </div>

                        </div>   :null

                }


                {openImport?

            <Fragment>

                <div class="drag-drop-wrapper">
                    <form>
                        <input type="file" class="file-dialog" multiple />
                    </form>
                    <div class="drag-drop">
                        <div class="drag-drop-area">
                        <svg width="81.823" height="71.434" viewBox="0 0 81.823 71.434">
                            <g id="Folder" transform="translate(-531.896 -391)">
                            <g id="folder-blank" transform="translate(531.989 391)">
                                <g>
                                <path d="M81.638,49.858V95.78a7.656,7.656,0,0,1-7.654,7.654H7.654A7.656,7.656,0,0,1,0,95.78V39.654A7.656,7.656,0,0,1,7.654,32H33.166l10.2,10.2H73.985A7.656,7.656,0,0,1,81.638,49.858Z" transform="translate(0 -32)" fill="#3b49b5"/>
                                </g>
                            </g>
                            <g id="Papers" transform="translate(-2 3)">
                                <rect width="43" height="57" rx="2" transform="matrix(0.998, -0.07, 0.07, 0.998, 538.872, 398.786)" fill="#d5d5d5"/>
                                <rect width="43" height="57" rx="2" transform="translate(554.329 396.131) rotate(3)" fill="#ebebeb"/>
                                <rect width="43" height="57" rx="2" transform="matrix(0.995, -0.105, 0.105, 0.995, 562.946, 400.62)" fill="#fff"/>
                            </g>
                            <rect width="81.823" height="55.141" rx="8" transform="translate(531.896 407.151)" fill="#4c5ff9"/>
                            </g>
                        </svg>
                        <div class="drag-drop-area-text">
                            Drag your documents here to start uploading.
                        </div>
                        <div class="drag-drop-area-separator">OR</div><br />
                        <div class='file-input'>
                    <input type='file' onChange={changeHandler}  />
                    {selectedFilename?
                    <span class='button'>Change File</span>:
                    <span class='button'>Choose</span>
                    }
                    {selectedFilename?
                    <span class='label' data-js-label>{selectedFilename}</span>:
                    <span class='label' data-js-label>No file selected</span>}

                    </div>


                    {successImport?

                    <Fragment>
                        <button class="drag-drop-area-button" style={{backgroundColor:"green", cursor:"default"}}  >Successfully Imported🥳</button>
                        <button class="drag-drop-area-button dismiss" onClick={dismissButtonImport}>Go Back</button>
                    </Fragment>:

                    <Fragment>
                        <button class="drag-drop-area-button" onClick={handleSubmission}>Import File</button>
                        <button class="drag-drop-area-button" style={{textDecoration:"none", background:"#2555"}} ><a style={{textDecoration:"none"}} href={api+"impex/download/sample_file.xlsx"}>Sample File</a></button>
                        <button class="drag-drop-area-button dismiss" onClick={dismissButtonImport}>Dismiss</button>
                    </Fragment>}

                        </div>
                    </div>

                </div> <br/> <br/>

                </Fragment>   :null

                }


{/* <div className="jumbotron-error">
                    <div>
                        <hr/>
                            <h4 style={{textAlign:"center"}}>{errors.error}</h4>
                        <hr/>
                    </div>
                </div> */}
                
                {errorImport?
                <Fragment>
                {importdataError?.map((errors,index)=> (



                <div class="drag-drop-wrapper error-list-wrapper">
                    
                        <div class="drag-drop-areas error-list">
                        <h4>{errors.error}</h4>

                    </div>
                </div>
                


                ))}
                </Fragment>:null
                }

            {confirmPromote?
                
                <div class="col-6 container  container-alert contianer-tab" style={{borderRadius:"10px", width:'60%'}}>
                <div class="alert mb-5 py-4 container-alert" role="alert">
                        <div class="px-3">
                            <h2 class="alert-headings" style={{fontSize:"25px", textAlign:"center"}}>Confirm to Promote</h2><br/>
                            <button className="downloadExport" type="button" onClick={()=>{promoteAthletic(selected)}}>Promote</button>
                            <span style={{width:"20px", padding:"20px"}}></span>    
                            <button onClick={dismissButton} className="downloadExport" data-dismiss="alert" aria-label="Close" data-abc="true">Dismiss</button> 
                        </div>
                </div>
                </div>:null

            }


           
            {exports?
                    <div class="col-6 container  container-alert contianer-tab" style={{borderRadius:"10px"}}>
                    <div class="alert mb-5 py-4 container-alert" role="alert">
                        {/* <div class="d-flex container-alert"> */}
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                <polyline points="22 4 12 14.01 9 11.01"></polyline>
                            </svg> */}
                            <div class="px-3">
                                <h2 class="alert-headings" style={{fontSize:"25px", textAlign:"center"}}>Thank you your data has been Exported!</h2><br/>
                                <button className="downloadExport">
                                    <a href={exportvalue}  onClick={dismissButton}>Download</a>
                                </button><span style={{width:"20px", padding:"20px"}}></span>    
                                <button onClick={dismissButton} className="downloadExport" data-dismiss="alert" aria-label="Close" data-abc="true">Dismiss</button> 
                            </div>
                        {/* </div> */}
                    </div>
                    </div>
                    :null
            }
 
            </aside>
        </div>

    )
}

export default AthletList; 

